import { useState } from 'react';
import { Container, Box } from 'theme-ui';

import { withInView } from '@utils';
import { Section, Link } from '@snippets';

import { themed } from './ShopByCategory.theme';
import { Schema } from './ShopByCategory.schema';
import { Header } from './Header';
import { Slider } from './Slider';

export const ShopByCategory = withInView(
  themed(({ theme, cms }) => {
    const { content, section, tiles, media } = cms;
    const { cta, ctaStyle } = content;
    const [headerPaddingRight, setHeaderPaddingRight] = useState(0);

    return (
      <Section section={section} sx={theme.wrapper}>
        <Container data-comp={ShopByCategory.displayName}>
          <Box sx={theme.header}>
            <Header content={content} headerPaddingRight={content?.cta?.text && content?.cta?.url ? headerPaddingRight : 0} />
          </Box>
          {tiles?.length > 0 && <Slider tiles={tiles} settings={media} setHeaderPaddingRight={setHeaderPaddingRight} />}
          {cta?.text && cta?.url && (
            <Box sx={theme.footer} className="md:hidden">
              <Link
                href={cta.url}
                newTab={cta.newTab}
                variant={`buttons.${ctaStyle || 'primary'}`}
                sx={theme.cta}
              >
                {cta.text}
              </Link>
            </Box>
          )}
        </Container>
      </Section>
    );
  }),
  { triggerOnce: true }
);

ShopByCategory.displayName = 'Shop By Category';
ShopByCategory.Schema = Schema;
